// @ts-nocheck
import React, { useState } from 'react';
import data_projects from '../data/projects_data';
import ProjectCard from '../components/ProjectCard';
import { motion } from 'framer-motion';

const Projects = () => {
  const [projects, setProjects] = useState(data_projects);
  const [active, setActive] = useState('All');

  const handleFilterCategory = (name) => {
    const new_array = data_projects.filter((project) =>
      project.category.includes(name)
    );
    setProjects(new_array);
    setActive(name);
  };

  const project_variants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: {
        delay: 0.1,
        duration: 0.2,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        ease: 'easeInOut',
      },
    },
  };

  return (
    <motion.div
      className='container projects'
      variants={project_variants}
      initial='hidden'
      animate='visible'
      exit='exit'
    >
      <div className='projects__navbar'>
        <div
          className={active === 'All' && 'projects__navbar-active'}
          onClick={() => {
            setProjects(data_projects);
            setActive('All');
          }}
        >
          All
        </div>
        <div
          className={active === 'js' && 'projects__navbar-active'}
          onClick={() => handleFilterCategory('js')}
        >
          Plain Javascript
        </div>
        <div
          className={active === 'react' && 'projects__navbar-active'}
          onClick={() => handleFilterCategory('react')}
        >
          React
        </div>
        {/* <div
          className={active === 'pwa' && 'projects__navbar-active'}
          onClick={() => handleFilterCategory('pwa')}
        >
          PWA
        </div> */}
        <div
          className={active === 'native' && 'projects__navbar-active'}
          onClick={() => handleFilterCategory('native')}
        >
          React Native
        </div>
      </div>
      <div className='row'>
        {projects.map((project) => (
          <ProjectCard key={project.name} project={project} />
        ))}
      </div>
    </motion.div>
  );
};

export default Projects;
